export const affiliateResources_actionType = {
    ALL_AFFILIATE_RESOURCES: 'ALL_AFFILIATE_RESOURCES',
    ALL_AFFILIATE_RESOURCES_SUCCESS: 'ALL_AFFILIATE_RESOURCES_SUCCESS',
    ALL_AFFILIATE_RESOURCES_ERROR: 'ALL_AFFILIATE_RESOURCES_ERROR',
    RESET_ALL_AFFILIATE_RESOURCES: 'RESET_ALL_AFFILIATE_RESOURCES'
};